import {
    ADD_LICENCIA_MAQUINA,
    DELETE_LICENCIA_MAQUINA,
    MODIFY_LICENCIA_MAQUINA
} from '../constants/action_types';

export function addLicenciaDeMaquina(licencia) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_LICENCIA_MAQUINA, payload: licencia });
    };
};


export function modifyLicenciaDeMaquina(licencia) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_LICENCIA_MAQUINA, payload: licencia });
    };
};

export function removeLicenciaDeMaquina(licencia) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_LICENCIA_MAQUINA, payload: licencia });
    };
};